/// <amd-module name="Repos/Views/PullRequest/Components/PullRequestDetails/OverviewExtensions" />
import * as React from "react";
import { IRegionComponentProperties, VssComponent, WrappedComponent } from "VSS/Platform/Layout";
import { getPullRequestViewService } from "../../PullRequestViewService";

export class OverviewExtensions extends VssComponent {
    public render() {
        const viewService = getPullRequestViewService(this.context.pageContext);

        return (
            <WrappedComponent<IRegionComponentProperties>
                dependencies={["ms.vss-code-web.pr-details-overview-extensions"]}
                wrappedType="ms.vss-web.region"
                wrappedProps={{
                    childComponentProperties: {
                        pullRequestId: viewService.getId(),
                        repository: viewService.getTargetRepository()
                    },
                    className: "rhythm-vertical-16",
                    componentRegion: "pullRequestDetailsOverviewExtensions"
                }}
            />
        );
    }
}
